import type { ColumnFiltersState, SortingState } from '@tanstack/react-table'
import type { FilterValue, SortModel, PaginationModel } from '@/shared/lib/api/api-types'

/**
 * Convert TanStack Table's ColumnFiltersState to the backend FilterModel format.
 * Each column filter value must be a FilterValue (set when calling column.setFilterValue).
 */
export function columnFiltersToApiFilter(
  columnFilters: ColumnFiltersState,
): Record<string, FilterValue> {
  const result: Record<string, FilterValue> = {}
  for (const filter of columnFilters) {
    if (filter.value !== undefined && filter.value !== null) {
      result[filter.id] = filter.value as FilterValue
    }
  }
  return result
}

/**
 * Convert TanStack Table's SortingState to the backend SortModel array.
 */
export function sortingToApiSorting(sorting: SortingState): SortModel[] {
  return sorting.map((s, index) => ({
    order: index,
    property: s.id,
    isDescending: s.desc,
  }))
}

/**
 * Convert TanStack Table's PaginationState to the backend PaginationModel.
 */
export function paginationToApiPagination(pagination: {
  pageIndex: number
  pageSize: number
}): PaginationModel {
  return {
    skip: pagination.pageIndex * pagination.pageSize,
    pageSize: pagination.pageSize,
  }
}
